import { createApiAction } from 'utils/helpers';

export const GET_SEO_LINKS = 'GET_SEO_LINKS';
export const GET_SEO_LINKS_SUCCESS = 'GET_SEO_LINKS_SUCCESS';
export const GET_SEO_LINKS_FAILURE = 'GET_SEO_LINKS_FAILURE';

export const getSEOLinks = createApiAction(GET_SEO_LINKS);
